var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div ng-if=\"$ctrl.vendor.id\"><h2>Stripe Account Connected</h2><p>Thanks! Your Stripe account has been connected to the EMUN1 platform.</p></div>";
var id1="stripe-connected.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;